import React from "react";
import CardSectionImageMenu from "../CardSectionImageMenu/CardSectionImageMenu";
import CardSectionBig from "../CardSectionBig/CardSectionBig";
import CardSectionLinkMenu from "../CardSectionLinkMenu/CardSectionLinkMenu";
import CardSectionCarousel from "../CardSectionCarousel/CardSectionCarousel";
import { Image } from "../Section/Section";

export interface Card {
  title: string;
  text: string;
  linkText: string;
  href: string;
  isSpa: boolean;
  image?: Image;
  linkOnImageAndTitleHref: string;
  linkOnImageAndTitleIsSpa: boolean;
}

export interface ICardSection {
  type?: "cardSection";
  cardType: "carousel" | "image-menu" | "big" | "link-menu";
  title: string;
  list: Card[];
}

const CardSection: React.FC<ICardSection> = (props) => {
  const { cardType, title, list } = props;

  switch (cardType) {
    case "image-menu":
      return (
        <CardSectionImageMenu
          title={title}
          menuButtons={list.map((card: Card) => ({
            alt: card.image?.alt || "",
            img: card.image?.url,
            href: card.href,
            info: card.text,
            name: card.linkText,
            isSpa: card.isSpa,
          }))}
          enabled={true}
        />
      );
    case "link-menu":
      return (
        <CardSectionLinkMenu
          title={title}
          menuButtons={list.map((card: Card) => ({
            alt: card.image?.alt || "",
            img: card.image?.url,
            href: card.href,
            info: card.text,
            name: card.linkText,
            isSpa: card.isSpa,
          }))}
          enabled={true}
        />
      );

    case "big":
      return (
        <CardSectionBig
          title={title}
          sections={list.map((card: Card) => ({
            title: card.title,
            href: card.href,
            image: card.image,
            descriptions: card.text,
            button: card.linkText,
            linkOnImageAndTitleHref: card.linkOnImageAndTitleHref,
            linkOnImageAndTitleIsSpa: card.linkOnImageAndTitleIsSpa,
            isSpa: card.isSpa,
          }))}
          enabled={true}
        />
      );
    case "carousel":
      return (
        <CardSectionCarousel
          header={title}
          itemList={list.map((card: Card) => ({
            title: card.title,
            imgAlt: card.image?.alt || "",
            href: card.href,
            img: card.image,
            paragraph: card.text,
            button: card.linkText,
            linkOnImageAndTitleHref: card.linkOnImageAndTitleHref,
            linkOnImageAndTitleIsSpa: card.linkOnImageAndTitleIsSpa,
            isSpa: card.isSpa,
          }))}
          enabled={true}
        />
      );
  }
  throw new Error(`Component type=${cardType} not found`);
};

export default CardSection;
